import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import {
	TRevenueSpendByTeam,
	TRevenueSpendByTeamRevenueCpa,
	TRevenueSpendByTeamRevenueSpend,
	TRevenueSpendByTeamRevenue,
	TRevenueAgg,
	EOfferType
} from '../../types'
import { ToolPanel } from '../ui'
import { RevenueSpendByTeamRevenueDetailsTable } from './RevenueSpendByTeamRevenueDetailsTable'
import dt from 'dayjs'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendByTeamRevenueDetailsModal = {
	revenueSpend: TRevenueSpendByTeam | TRevenueSpendByTeamRevenue | TRevenueSpendByTeamRevenueCpa | TRevenueSpendByTeamRevenueSpend | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
	offerType?: EOfferType;
	isFullscreenModal?: boolean;
}

export const RevenueSpendByTeamRevenueDetailsModal = (
	props: IRevenueSpendByTeamRevenueDetailsModal
) => {
	const { revenueSpend, show, take = 10, onClose, offerType, isFullscreenModal = false } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	let targetItems: TRevenueAgg[] = []
	let modeLabel = ''

	if (!!revenueSpend) {
		switch (offerType) {
			case EOfferType.cpa: {
				targetItems = 'revenueCpa' in revenueSpend ? revenueSpend.revenueCpa : []
				modeLabel = t(ALL_LANG_KEY.revenue_spend_crud_modal.label_mode_revenue_cpa) //'Revenue Cpa'
				break
			}
			case EOfferType.spend: {
				targetItems = 'revenueSpend' in revenueSpend ? revenueSpend.revenueSpend : []
				modeLabel = t(ALL_LANG_KEY.revenue_spend_crud_modal.label_mode_revenue_spend) //'Revenue Spend'
				break
			}
			default: {
				targetItems = 'revenue' in revenueSpend ? revenueSpend.revenue : []
				modeLabel = t(ALL_LANG_KEY.revenue_spend_crud_modal.label_mode_revenue) //'Revenue'
				break
			}
		}
	}

	const _getDateFormat = (at: Date) => {
		return dt.utc(at).isValid() ? dt.utc(at).format('L') : '-'
	}

	const isSingleView = !!(revenueSpend && ('teamReport' in revenueSpend))
	const teamLabel = isSingleView && `'${revenueSpend?.teamReport ?? ''}'`
	const dayLabel = isSingleView && _getDateFormat(revenueSpend?.at)

	return <>
		<Modal
			show={show}
			onHide={onClose}
			size="xl"
			fullscreen={isFullscreenModal ? true : undefined}
			className={'modal-with-sticky scroll'}
		>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>
					{
						isSingleView ?
							`${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_by_team_revenue, {
								mode: modeLabel,
								team: teamLabel,
								date: dayLabel
							})}` :
							`${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_by_team_revenue_total, { mode: modeLabel })}`
					}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<RevenueSpendByTeamRevenueDetailsTable
					items={targetItems ?? []}
					skip={skip}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary"
					        onClick={onClose}
					>
						{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_close)}`}
					</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
